/* tslint:disable */
export enum OrganizationalUnit {
  Operation = 1,
  Hr = 2,
  Finance = 3
}